export default {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  REQUESTED: 'requested',
  PENDING_REQUEST: 'pending_request',
};
